import { DirectSubChannel, SensorPortCommunicationMode } from "../../../portConfigs.js";
import { SensorClusterConfig, SensorElementOutput } from "../types.js";

// ─── 5V voltage sensor (ADC, raw passthrough) ────────────────────────────────
//
// A raw 0-5V analog input wired directly to a single ADC_5V sub-channel. No
// calibration curve — the digitalVoltage element's unity conversion reports the
// voltage as-is, matching the legacy `voltage5v` sensor type's identity conversion.

const voltage5vElements: SensorElementOutput<"digitalVoltage">[] = [
    {
        sensorElementConfigKey: "digitalVoltage",
        parameters: {},
        legalConvertedRange: [0, null],
        subChannel: DirectSubChannel.ADC_5V,
    },
];

export const voltage5vClusterConfigs: Record<string, SensorClusterConfig<Record<string, never>>> = {
    Voltage5V: {
        communicationMode: SensorPortCommunicationMode.DIRECT,
        requiredSubChannels: [DirectSubChannel.ADC_5V],
        optionalSubChannels: [],
        isPermanentlyAttached: false,
        parameterConfigs: {},
        manufacturerName: "Unknown",
        modelName: "N/A",
        friendlyName: "5V Sensor",
        friendlyShortName: "5V Sensor",
        generateSensorElements: () => voltage5vElements,
        migrationProperties: {
            legacySensorType: "voltage5v",
            // Both the legacy sensor and the cluster have no configurable params.
            legacyParametersToClusterParameters: () => ({}),
            clusterParametersToLegacyParameters: () => ({}),
        },
    },
};
